import React from 'react';
import { Alert as BsAlert } from 'react-bootstrap';
import { useAlerts } from './AlertContext';
import type { Alert } from './alertStore';

const Alerts: React.FC = () => {
  const { alerts, clear } = useAlerts();

  if (alerts.length === 0) {
    return null;
  }

  const handleClose = (alert: Alert) => {
    clear(alert);
  };

  return (
    <div className="mb-3 mt-3">
      {alerts.map((alert, index) => (
        <BsAlert
          key={`${alert.severity}-${index}-${alert.message}`}
          variant={alert.severity}
          onClose={() => handleClose(alert)}
          dismissible
          className="alert">
          {alert.message}
        </BsAlert>
      ))}
    </div>
  );
};

export default Alerts;
